const envVars = process.env;
const environmentVariables = {
  apiUrl: envVars.REACT_APP_API_URL,
  clientId: envVars.REACT_APP_CLIENT_ID,
  redisUrl: envVars.REACT_APP_REDIS_URL,
  cdnUrl:envVars.REACT_APP_CDN_URL,
  gameDashboardUrl:envVars.REACT_APP_GAME_DASHBOARD_URL
};
export default environmentVariables;
